document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-undef
  const isKlaroActive = !!klaro && typeof klaro.show === 'function' // klaro and it's manager are never null, but the show function is only present if it's properly initialized
  const manager = isKlaroActive ? klaro.getManager() : window.myConsentManager

  const checkRequiredConsents = (manager) => {
    const callConsentFallback = ($element, consent, consentGranted) => {
      const callback = $element.getAttribute('data-required-consent-callback')
      if (
        callback &&
        window[callback] &&
        typeof window[callback] == 'function'
      ) {
        window[callback](consent, consentGranted)
      }
    }

    for (const consent of Object.keys(manager.consents)) {
      const $elementsWithRequiredConsent = document.querySelectorAll(
        `[data-required-consent="${consent}"]`
      )
      const $fallbackElements = document.querySelectorAll(
        `[data-required-consent-fallback="${consent}"]`
      )

      const consentGranted = manager.states[consent]

      if (consentGranted) {
        for (const $element of $elementsWithRequiredConsent) {
          $element.classList.add('required-consent-granted')

          callConsentFallback($element, consent, consentGranted)
        }
        for (const $fallbackElement of $fallbackElements) {
          $fallbackElement.classList.add('required-consent-granted')
          callConsentFallback($fallbackElement, consent, consentGranted)
        }
      } else {
        for (const $element of $elementsWithRequiredConsent) {
          $element.classList.remove('required-consent-granted')
          callConsentFallback($element, consent, consentGranted)
        }
        for (const $fallbackElement of $fallbackElements) {
          $fallbackElement.classList.remove('required-consent-granted')
          callConsentFallback($fallbackElement, consent, consentGranted)
        }
      }
    }
  }

  checkRequiredConsents(manager)
  manager.watch({
    update: () => checkRequiredConsents(manager),
  })

  document.body.addEventListener('click', (e) => {
    if (e.target.hasAttribute('data-give-consent')) {
      const consents = e.target.getAttribute('data-give-consent').split(',')
      for (const consent of consents) {
        manager.updateConsent(consent, true)
      }

      manager.saveAndApplyConsents()
    }

    if (e.target.hasAttribute('data-open-consent') && isKlaroActive) {
      // eslint-disable-next-line no-undef
      klaro.show()
    }
  })
})
